<template>
  <div>
    <slot name="trigger" v-bind:showModal="showModal"></slot>

    <transition name="modal-bg-fade">
      <div v-if="modalIsVisible" @keyup.esc="">
        <div
          class="fixed bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center z-10"
        >
          <div class="fixed inset-0 transition-opacity">
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>

          <div
            :class="`bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-${modalSize} max-h-screen sm:w-full sm:p-6 relative`"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
          >
            <div class="absolute top-0 right-0 pt-4 pr-4">
              <button
                type="button"
                class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                @click="hideModal"
              >
                <span class="sr-only">Close</span>
                <!-- Heroicon name: outline/x -->
                <svg
                  class="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="2"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <div>
              <div class="text-center">
                <h3
                  class="text-2xl leading-6 font-medium text-primary-800"
                  id="modal-headline"
                >
                  <slot name="title" />
                </h3>
                <div class="mt-3 text-gray-500">
                  <slot></slot>
                </div>
              </div>
            </div>

            <div class="mt-5 pt-2 border-t border-gray-200">
              <slot name="footer" v-bind:hideModal="hideModal"></slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref, onUnmounted } from "vue";

defineOptions({
  name: "ModalTemplate",
});

const props = defineProps({
  modalSize: {
    type: String,
    default: "md",
  },
});

const modalIsVisible = ref(false);

const showModal = () => {
  modalIsVisible.value = true;

  document.addEventListener("keyup", hideModalOnEscape);
};

const hideModalOnEscape = (event) => {
  if (event.key === "Escape") {
    hideModal();
  }
};

const hideModal = () => {
  modalIsVisible.value = false;

  document.removeEventListener("keyup", hideModalOnEscape);
};

onUnmounted(() => {
  document.removeEventListener("keyup", hideModalOnEscape);
});

defineExpose({
  showModal,
  hideModal,
});
</script>

<style>
.modal-bg-fade-enter {
  opacity: 0;
}

.modal-bg-fade-enter-active,
.modal-bg-fade-leave-active {
  transition: opacity 200ms ease-out;
}

.modal-bg-fade-leave-to {
  opacity: 0;
}
</style>
